<template>
  <div class="check-account-wraper">
    <el-dialog :visible.sync="showUpdatePasswordDialog" title="更改密码" width="400px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <template slot="title">
        <h2 style="text-align:center; font-size:18px;font-weight:bold;">更改密码</h2>
      </template>
      <!-- 修改密码表单内容 -->
      <div>
        <el-form :model="updatePasswordForm" :rules="dynamicRules" ref="passwordForm" size="small">
          <el-form-item label="当前密码" prop="oldPassword">
            <el-input v-model="updatePasswordForm.oldPassword" show-password placeholder="请输入当前密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword1">
            <el-input v-model="updatePasswordForm.newPassword1" show-password placeholder="请输入新密码"></el-input>
            <span style="padding-left:10px;font-size:12px;color:#999;">{{$store.state.user.identity === 1?'密码长度为8~16个字符':'至少8个字符长度'}}，数字+字母{{$store.state.user.identity === 1?'+符号':''}}</span>
          </el-form-item>
          <el-form-item label="重新输入新密码" prop="newPassword2">
            <el-input v-model="updatePasswordForm.newPassword2" show-password placeholder="请再次输入新密码"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="methodCancelUpdatePassword" size="small">取 消</el-button>
        <el-button type="primary" @click="methodUpdatePassword('passwordForm')" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
// CryptoJS.MD5(loginForm.password).toString(CryptoJS.enc.Base64),
// 通过VueX监听触发
// 登录后需要先把登录密码存在vuex中

import { stuUpdateStudentPassword } from '@/api/educational'
import { api_tchCheckPwd, api_stuCheckPwd, api_tchPersonalColumnUpdatePassword } from '@/api/javaApi'
export default {
  name: 'globalCheckAccount', // 检测账号
  data() {
    return {
      showUpdatePasswordDialog: false,
      updatePasswordForm: {
        oldPassword: '',
        newPassword1: '',
        newPassword2: '',
      }
    }
  },
  computed: {
    dynamicRules() {
      const identity = this.$store.state.user.identity;
      const pattern = identity === 1
        ? /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()\-+={}[\]:;'<>,.?/~_\\|]).{8,16}$/
        : /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
      const characterRequirement = identity === 1
        ? '密码长度为8~16个字符，必须包含至少一个字母、一个数字和一个特殊符号'
        : '密码至少8个字符长度，必须包含至少一个字母和一个数字';
      return {
        oldPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword1: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern, message: characterRequirement, trigger: 'blur' }
        ],
        newPassword2: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ]
      };
    },
    passwordLengthRequirement() {
      return `至少${this.dynamicRules.newPassword1[1].min}个字符`;
    },
    passwordCharacterRequirement() {
      return this.dynamicRules.newPassword1[2].message;
    },
    checkAccount: {
      get() {
        return this.$store.state.globalCheck.checkAccountState;
      },
      set(val) {
        if (!val) {
          this.$store.dispatch('storeMethodCheckAccount', false);
        }
      }
    }
  },
  watch: {
    checkAccount: {
      handler(val) {
        if (val) {
          this.methodCheckAccount();
        }
      },
    }
  },
  methods: {
    async methodCheckAccount() {
      const today = this.getTodayDateString();
      if (!this.shouldShowReminder(today)) {
        return this.checkAccount = false;
      }
      const needChange = await this.methodTchCheckPwd()
      window.localStorage.setItem('validPassword', needChange)
      if (!needChange) { // 等于false，不提示
        return false;
      }
      this.$confirm('您的密码过于简单，请增强密码强度！', {
        title: '提示',
        type: 'warning',
        cancelButtonText: '关闭提醒',
        confirmButtonText: '修改密码',
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false,
        beforeClose: (action, instance, done) => {
          console.log(action, instance.action);
          if (action === 'confirm') {
            this.showUpdatePasswordDialog = true;
          } else if (action === 'cancel') {
            // 今日不再提醒
            const today = this.getTodayDateString();
            this.setLastIgnoredDate(today);
            this.checkAccount = false;
          } else { // close
            // 本日内再次进入会调用
            this.checkAccount = false;
          }
          done();
        }
      }).then(() => {
        // done之后执行
      }).catch(() => {
        // 处理取消操作
      });
    },
    methodUpdatePassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) { // 通过密码长度校验
          if (this.updatePasswordForm.newPassword1 !== this.updatePasswordForm.newPassword2) {
            return this.$message.error('两次输入密码不一致')
          }
          if (this.$store.state.user.identity === 2) {
            stuUpdateStudentPassword({
              oldPassword: CryptoJS.MD5(this.updatePasswordForm.oldPassword).toString(
                CryptoJS.enc.Base64
              ),
              newPassword: CryptoJS.MD5(this.updatePasswordForm.newPassword1).toString(
                CryptoJS.enc.Base64
              ),
            }).then((res) => {
              console.log('修改密码')
              console.log(res)
              this.$message.success('密码重置成功,请重新登录')
              this.showUpdatePasswordDialog = false
              this.$store.dispatch('LogOut').then(() => {
                this.$router.push({ path: '/login' })
              })
            })
          } else {
            api_tchPersonalColumnUpdatePassword({
              oldPassword: CryptoJS.MD5(this.updatePasswordForm.oldPassword).toString(
                CryptoJS.enc.Base64
              ),
              newPassword: CryptoJS.MD5(this.updatePasswordForm.newPassword1).toString(
                CryptoJS.enc.Base64
              ),
            }).then((res) => {
              console.log('修改密码', res)
              if (res && res.error) {
                this.$message.error(res.error.message)
              } else {
                this.$message.success('密码重置成功,请重新登录')
                this.showUpdatePasswordDialog = false
                this.$store.dispatch('LogOut').then(() => {
                  this.$router.push({ path: '/login' })
                })
              }
            })
          }
        }
      })
    },
    methodTchCheckPwd() {
      // 先判断密码是否简单
      const validPassword = window.localStorage.getItem('validPassword');
      if (validPassword) {
        return window.JSON.parse(validPassword)
      }
      if (this.$store.state.user.identity === 1) {
        return api_tchCheckPwd()
      } else {
        const stuCheckPwdRes = api_stuCheckPwd()
        if (stuCheckPwdRes) {
          const res = this.$store.dispatch('storeStuGetStuPwdRemind');
          return res;
        } else {
          return stuCheckPwdRes;
        }
      }
    },
    // 取消修改密码，也等同于今日不再修改
    methodCancelUpdatePassword() {
      // 今日不再提醒
      const today = this.getTodayDateString();
      this.setLastIgnoredDate(today);
      this.showUpdatePasswordDialog = false;
    },
    // 获取固定格式的今日日期
    getTodayDateString() {
      const now = new Date();
      return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    },
    // 判断传入日期与存储日期是否相等
    shouldShowReminder(today) {
      const lastIgnoredDate = localStorage.getItem('lastIgnoredDate');
      return lastIgnoredDate !== today;
    },
    setLastIgnoredDate(today) {
      localStorage.setItem('lastIgnoredDate', today);
    }
  }
}
</script>

<style scoped lang="scss">
</style>



